import { Hero01home } from './Images.js';
import { Kellyclarkson } from './Images.js';
import { Nbcnightly } from './Images.js';
import { Nyt } from './Images.js';
import { Rachaelray } from './Images.js';
import { Startalk } from './Images.js';
import { Stephencolbert } from './Images.js';
import { Todayshow } from './Images.js';
import { Washingtonpost } from './Images.js';

import HomeCarousel from './HomeCarousel';
import LazyImage from './components/LazyImage';
import HeroImage from './components/HeroImage';

import './css/App.css';
import { useDocumentTitle } from "./hooks/useDocumentTitle";
import { useMediaQuery } from 'react-responsive';

function Home() {
  useDocumentTitle("Home");
  const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

  return (
      <div className="home-mainbody"> 

        <div className={isMobile ? "hero-image-area-mobile" : "hero-image-area"}>
            <HeroImage 
                src={Hero01home} 
                alt="Kate the Chemist - Bringing Science to Live TV"
            />
        </div>
        
        <div className={isMobile ? "featured-area-mobile" : "featured-area"}>
            <LazyImage className={isMobile ? "featured-logo-img-mobile" :  "featured-logo-img"} src={ Startalk} alt="Star Talk with Neil deGrasse Tyson" />
            <LazyImage className={isMobile ? "featured-logo-img-mobile" :  "featured-logo-img"} src={ Kellyclarkson } alt="The Kelly Clarkson Show" />
            <LazyImage className={isMobile ? "featured-logo-img-mobile" :  "featured-logo-img"} src={Todayshow} alt="The Today Show" />
            <LazyImage className="featured-logo-img" src={Nbcnightly} alt="NBC Nightly News" />
            <LazyImage className={isMobile ? "featured-logo-img-mobile" :  "featured-logo-img"} src={Stephencolbert} alt="Late Night with Stephen Colbert" />
            <LazyImage className={isMobile ? "featured-logo-img-mobile" :  "featured-logo-img"} src={Washingtonpost} alt="Washington Post" />
            <LazyImage className={isMobile ? "featured-logo-img-mobile" :  "featured-logo-img"} src={Nyt} alt="New York Times" />
            <LazyImage className={isMobile ? "featured-logo-img-mobile" :  "featured-logo-img"} src={Rachaelray} alt="The Rachael Ray Show" />
        </div>

        <div className={isMobile ? "intro-paragraph-area-mobile" : "intro-paragraph-area"}>
          <h1>Kate the Chemist</h1>
          <h2><em>Bringing Science to Life</em></h2>
          Kate the Chemist brings science to life with explosive experiments performed live on TV shows—including <b>The Today Show, The Kelly Clarkson Show, NBC Nightly News, The Rachael Ray Show, Star Talk with Neil deGrasse Tyson,</b> and <b>Late Night with Stephen Colbert</b>.
          <br /><br />
          Dr. Kate Biberdorf has been featured in articles for the <b>Washington Post, </b>the <b>Wall Street Journal, </b>and the <b>New York Times</b>.  Kate authored the bestseller The Big Book of Experiments, along with The Awesome Book of Edible Experiments for Kids, and It's Elemental: The Hidden Chemistry in Everything.  She also has a five-book fiction series called "Kate the Chemist."

        </div>

        <div className="blue-bg-area">
            <HomeCarousel />
        </div>

      </div>

  );
}

export default Home;
